import { Options, RegionSelectOption } from '@modules/EnquiryForm/EnquiryForm.types';
import React, { forwardRef } from 'react';
import './FormSelect.scss';

type FormSelectProps = {
  label: string;
  required: boolean;
  selectText: string;
  hasGroups?: boolean;
  options: Options | RegionSelectOption[];
};

export const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(
  ({ label, options, required, selectText, hasGroups = true, ...props }, ref) => {
    return (
      <div className='c-form-top'>
        <label htmlFor='' className='c-select-field-label'>
          {label}
          {required ? ' *' : ''}
        </label>
        <select ref={ref} className='c-form-select' required={required} {...props}>
          <option value='select'>{selectText}</option>
          {hasGroups &&
            options.map((group, index) => (
              <optgroup label={group.GroupHeading} key={index}>
                {group.Options.map((option, i) => (
                  <option key={i} value={option.Value}>
                    {option.Text}
                  </option>
                ))}
              </optgroup>
            ))}

          {!hasGroups &&
            options.map((option, index) => (
              <option key={index} value={option.Value}>
                {option.Text}
              </option>
            ))}
        </select>
      </div>
    );
  }
);
